import React from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
function CatHomisLive() {
return ( <div className="bg-light py-4">


  <Container>

    {/* TITLE */}
    <h2 className="text-center mb-3">CAT HOMIS SYSTEM</h2>
    <p className="text-center text-muted mb-4">
      Hotel & Room Management Demo Access
    </p>

    {/* 2 COLUMNS */}
    <Row className="g-4 justify-content-center">

      {/* ADMIN */}
      <Col md={5}>
        <Card className="shadow-sm h-100">
          <Card.Body>

            <h5 className="text-center mb-3">Admin</h5>

            <Button className="w-100 mb-3" variant="primary">
              Admin Login
            </Button>

            <Form>
              <Form.Group className="mb-2">
                <Form.Label>ID</Form.Label>
                <Form.Control type="text" value="info@chrisalphatech.com" readOnly />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="text" value="adminchris" readOnly />
              </Form.Group>
            </Form>

          </Card.Body>
        </Card>
      </Col>

      {/* RECEPTIONIST */}
      <Col md={5}>
        <Card className="shadow-sm h-100">
          <Card.Body>

            <h5 className="text-center mb-3">Receptionist</h5>

            <Button className="w-100 mb-3" variant="success">
              Receptionist Login
            </Button>

            <Form>
              <Form.Group className="mb-2">
                <Form.Label>ID</Form.Label>
                <Form.Control type="text" value="info@chrisalpha.com" readOnly />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="text" value="chrisalpha" readOnly />
              </Form.Group>
            </Form>

          </Card.Body>
        </Card>
      </Col>

    </Row>

    {/* INFO SECTION */}
    <div className="mt-4">
      <Card className="shadow-sm">
        <Card.Body>
          <h5 className="text-center mb-3">How It Works</h5>
          <ul>
            <li>Register guests</li>
            <li>Assign rooms</li>
            <li>Track check-in and check-out</li>
            <li>Generate invoices and reports</li>
          </ul>
        </Card.Body>
      </Card>
    </div>

    {/* BUTTON + LINK SAME LINE */}
    <div className="d-flex justify-content-center align-items-center gap-3 mt-4">

      <a
        href="https://cathomis.chrisalphatech.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          size="lg"
          style={{
            backgroundColor: "#0d6eff",
            border: "none"
          }}
        >
          Open Live Demo
        </Button>
      </a>

      <Link 
        to="/cat_homis" 
        style={{ 
          color: "#0d6eff", 
          fontWeight: "500",
          marginLeft: "20px"
        }}
      >
        Read More 
      </Link>

    </div>

  </Container>

</div>


);
}

export default CatHomisLive;
